export default {
      id: "ready-to-complete-usage",
      viewBox: "0 0 16 24",
      url: __webpack_public_path__ + "icons.svg#ready-to-complete",
      toString: function () {
        return this.url;
      }
    }